


































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { BContainer, BRow, BCol, BCard, BCardBody } from 'bootstrap-vue';
import Navbar from '@/components/Navbar.vue';
import PageFooter from '@/components/PageFooter.vue';

@Component({
    components: {
        'b-container': BContainer,
        'b-row': BRow,
        'b-col': BCol,
        'b-card': BCard,
        'b-card-body': BCardBody,
        'navbar': Navbar,
        'page-footer': PageFooter
    }
})
export default class DefaultLayout extends Vue {
    @Prop() currentView!: string
}
